var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7930_3016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.12 19.7C13.036 20.752 11.84 20.588 10.7 20.092C9.48797 19.586 8.37997 19.554 7.09997 20.092C5.50597 20.78 4.65997 20.58 3.69997 19.7C-1.72003 14.12 -0.920029 5.62 5.23997 5.3C6.73397 5.38 7.77997 6.126 8.65997 6.188C9.96797 5.922 11.22 5.16001 12.62 5.26001C14.302 5.396 15.56 6.06 16.4 7.254C12.94 9.33399 13.76 13.894 16.938 15.174C16.302 16.844 15.486 18.494 14.118 19.714L14.12 19.7ZM8.53997 5.24001C8.37797 2.76001 10.388 0.720019 12.7 0.52002C13.018 3.38001 10.1 5.52 8.53997 5.24001Z",
    fill: "#0B1526"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7930_3016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.84,
    height: 20,
    fill: "white",
    transform: "translate(0.0799561 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.a8f2662bb1d6c0a28e2c4f1852ddf376.svg";
export { ForwardRef as ReactComponent };